export default "/images/debe0e1f9d89b42ddb8cc3e26fc73eac.avif";